import React from 'react';
import { flushSync } from 'react-dom';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { Types } from 'utils/constants';
import useRecordStore from 'contexts/record-store';
import ConfirmDialog from 'components/confirm-dialog';

const DuplicateDialog = ({ recordId, recordType, onClose, setIsLoading }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation('general');
  const recordStore = useRecordStore();
  const record = recordStore.useRecord(recordType, recordId).ornull;
  const eventId = recordType === Types.Record.EVENT 
    ? recordId 
    : record
      ? record.get().eventId
      : null;
  const eventRecord = recordStore.useRecord(Types.Record.EVENT, eventId).ornull
  const eventName = eventRecord ? eventRecord.get().name : '';
  const [confirmDuplicate, setConfirmDuplicate] = React.useState();
  const typeName = Types.Record.getName(t, recordType);

  React.useEffect(() => {
    const duplicateRecord = async () => {
      const confirmed = await confirmDuplicate();
  
      if (confirmed) {
        setIsLoading(true);
  
        try {
          if (recordType === Types.Record.EVENT) {
            await recordStore.duplicateEvent(recordId);
          } else if (recordType === Types.Record.EXERCISE) {
            await recordStore.duplicateExercise(recordId);
          }
  
          enqueueSnackbar(`${typeName} duplicated`, {
            variant: 'success'
          });
        } catch (e) {
          enqueueSnackbar(`Error duplicating ${typeName.toLowerCase()}: ${e.message}`, {
            variant: 'error',
            persist: true,
            anchorOrigin: {
              vertical: "top",
              horizontal: "center"
            }
          });
        } finally {
          flushSync(() => {
            setIsLoading(false);
          });
          onClose();
        }
      } else {
        setTimeout(() => onClose(), 100);
      }
    }

    if (confirmDuplicate) {
      duplicateRecord();
    }

  // recordStore is a setter
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmDuplicate, onClose, recordId, recordType, setIsLoading, typeName, enqueueSnackbar]);


  const content = () => {
    if (recordType === Types.Record.EVENT) {
      return `Duplicate the event and all associated exercises for "${eventName}"?`;
    } else if (recordType === Types.Record.EXERCISE) {
      return `Duplicate the exercise "${record.get().name}" within the event "${eventName}"?`;
    }
  }


  return (
    <>
    { record &&
    <ConfirmDialog
      title={`Duplicate ${typeName}`}
      titleIcon='copy'
      content={content()}
      setConfirm={setConfirmDuplicate} />
    }
    </>
  );
}

export default DuplicateDialog;